<script>
  import { domainName, record } from '../stores.js';
  import DMARCCreateForm from './dmarcForm.svelte';

  let createDmarc = false;
</script>

<div class="record-box record-404 text-center">
  <div id="headingRaw" class="box-label">
    <h5 class="mb-3">No DMARC Record Found: <a class="link-arrow" href="https://{$domainName}" target="_blank">{$domainName}</a></h5>
    <button on:click|preventDefault={() => createDmarc = true} disabled={createDmarc} class="btn btn-1" id="create-dmarc">Create DMARC Record</button>
  </div>
  {#if createDmarc}
    <div class="box-detail found-no-record">
      <DMARCCreateForm />
    </div>
  {/if}
</div>

<style>

</style>
